import { useRef, useState } from 'react';

// Sits at the bottom of the asset library and doubles as its empty state.
// An empty library previously rendered a large "Nothing here yet" panel,
// which read as unfinished rather than deliberately empty — a dropzone is
// the same footprint but offers the next action instead of an apology.
export default function UploadDropzone({ onFiles, empty }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const takeFirstImage = (fileList) => {
    const file = Array.from(fileList || []).find((f) => f.type.startsWith('image/'));
    if (file) onFiles(file);
  };

  return (
    <div
      className={
        'upload-dropzone' + (dragging ? ' dragging' : '') + (empty ? ' upload-dropzone-empty' : '')
      }
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        takeFirstImage(e.dataTransfer.files);
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          inputRef.current?.click();
        }
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={(e) => {
          takeFirstImage(e.target.files);
          e.target.value = '';
        }}
      />
      <span className="upload-dropzone-icon">↑</span>
      <span className="upload-dropzone-text">
        {empty ? 'No campaign assets yet — ' : ''}
        <strong>Drag &amp; drop an image</strong> or click to upload
      </span>
      <span className="upload-dropzone-hint">JPG, PNG or WEBP</span>
    </div>
  );
}
